import React, { Fragment, useContext, useEffect } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import TableCitiesComponent from "./TableCitiesComponent";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import TableSearch from "../../../Shared/Components/Search/TableSearch";
import { hasPermission } from "../../../Shared/Utils/userUtils";
import CityContext from "../Context/Index";
import { PlusCircle } from "react-feather";
import CityForm from "./CityForm";

export default function Index() {
  const { modalTogle, setItem, setSearchTerm } = useContext(CityContext);
  const handleNew = () => {
    console.log("handleNew");

    setItem({});
    modalTogle();
  };
  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, []);
  return (
    <Fragment>
      <Breadcrumbs parent="Admin" title="Ciudades" mainTitle="Ciudades" />
      <Container fluid={true}>
        <Row>
          {/* <ListHeader></ListHeader> */}
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <Row className="project-list">
                  <Col md="4">{<TableSearch onSearch={setSearchTerm} />}</Col>
                  <Col sm="8" className="p-0">
                    {hasPermission("create_list") ? (
                      <div className="text-end">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn btn-primary text-white",
                            onClick: handleNew,
                          }}
                        >
                          <PlusCircle />
                          Nueva ciudad
                        </Btn>
                        <CityForm />
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <TableCitiesComponent />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
